import { LargeClassCodeComboBoxComponent } from '../large-class-code-combo-box/large-class-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';

/**
 * 大分類コードコンボボックスManageクラス
 *
 * @export LargeClassCodeComboBoxModel
 * @class LargeClassCodeComboBoxModel
 */
export class LargeClassCodeComboBoxModel {

  public largeClassList: Array<any> = Array<any>();
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コンボボックスインスタンス
  public component: LargeClassCodeComboBoxComponent;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setLargeClassCode: string = <string>'';
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // 初期設定インデックス
  public selectedIndex: number = <number>-1;
  // 受注コード初期化済フラグ
  public isInitOrderCode: boolean = <boolean>false;

  /**
   * 大分類コードリストアップデート
   *
   * @param {*} serverData
   * @memberof LargeClassCodeComboBoxModel
   */
  public updateLargeClassList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      const ob: any = {
        ClassCode: '',
        LargeClassCode: '',
        LargeClassName: '',
        LargeClassCodeName: ''
      };
      tempDataList.splice(index, 0, ob);
      index = 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].LargeClassCodeName =
        tempDataList[index].LargeClassCode + ':' + tempDataList[index].LargeClassName;
    }

    this.largeClassList = tempDataList;
    this.completeUpdateFlg = <boolean>true;

    // 画面側で設定する
    this.component.updateSelectedLargeClassCode();
    this.component.updateSelectedIndex();
  }

}
